import { render, staticRenderFns } from "./CardRegistrosNoRegion.vue?vue&type=template&id=4eeddedd&scoped=true"
import script from "./CardRegistrosNoRegion.vue?vue&type=script&lang=js"
export * from "./CardRegistrosNoRegion.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrosNoRegion.vue?vue&type=style&index=0&id=4eeddedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeddedd",
  null
  
)

export default component.exports